import { Spacing16 } from 'autogen/design-tokens/tokens';
import type { CountDownBannerModel } from 'autogen/swagger/all';
import styled, { css } from 'styled-components';
import LiveEventBanner from './components/LiveEventBanner';
import OneToOneBanner from './components/OneToOneBanner';

const spacing = css`
    margin-bottom: ${Spacing16};
`;

const StyledLiveEventBanner = styled(LiveEventBanner)`
    ${spacing}
`;

const StyledOneToOneBanner = styled(OneToOneBanner)`
    ${spacing}
`;

export default function BannerRenderer({ model }: { model: CountDownBannerModel }) {
    const { countDownBannerType } = model;

    switch (countDownBannerType) {
        case 'BookingVirtual':
            return <StyledOneToOneBanner model={model} />;
        case 'LiveEvent':
            return <StyledLiveEventBanner model={model} />;
        default:
            return null;
    }
}
